import { Button } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { IconFileExcel } from '@tabler/icons-react';
import { whiteIconButtonStyle } from '../../theme/styling/buttonStyling';
import { defaultIconStyle } from '../../theme/styling/iconStyling';
import { ExportModal } from './ExportModal';

interface ExportButtonProps {
	apiPath: string;
	title?: string;
	disablePdf?: boolean;
}

export function ExportButton({
	apiPath,
	title,
	disablePdf = false,
}: ExportButtonProps) {
	const [isOpen, { open, close }] = useDisclosure(false);

	return (
		<>
			<Button {...whiteIconButtonStyle} onClick={() => open()}>
				<IconFileExcel {...defaultIconStyle} />
			</Button>
			<ExportModal
				isOpened={isOpen}
				close={close}
				apiPath={apiPath}
				title={title}
				disablePdf={disablePdf}
			/>
		</>
	);
}
